import React from 'react';
import styled from 'styled-components';
import Breadcrumb from '@ingka/breadcrumb';

const BreadCrumb = styled(Breadcrumb)`
  margin-top: 30px;
`;

interface CrumbItems {
  url: string;
  text: string;
}

// eslint-disable-next-line
interface Crumbs extends Array<CrumbItems> {}

interface Crumb {
  crumbs: Crumbs;
}

const Breadcrumbs = (crumbs: Crumb): JSX.Element => (
  <BreadCrumb items={crumbs.crumbs} />
);

export default Breadcrumbs;
